export enum Storage {
  acceptedUseTerms = '@PE:acceptedUseTerms',
  token = '@PE:token',
}
